var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWithdrawunfilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    stroke: "#ffffff",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 7C3 5.9 3.9 5 5 5H17C18.1 5 19 5.9 19 7V9H15C13.3 9 12 10.3 12 12C12 13.7 13.3 15 15 15H19V17C19 18.1 18.1 19 17 19H5C3.9 19 3 18.1 3 17V7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 12L18 9V11H22V13H18V15L14 12Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithdrawunfilled);
export default __webpack_public_path__ + "static/media/withdrawunfilled.ba95d6ab3bd25408784b43c7c2e36d72.svg";
export { ForwardRef as ReactComponent };